/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.pill {
  --pill-vertical-padding: calc((var(--pill-height) - var(--pill-content-height) - 2px) / 2);

  display: flex;
  flex-direction: row;
  justify-content: center;
  height: var(--pill-height);

  margin: 0 var(--pill-spacing);
  padding: var(--pill-vertical-padding) var(--pill-spacing);

  border-radius: calc(var(--pill-height) / 2);
  border: 1px solid var(--neutral-color);
}

/* pill--solid comes last to override font color */
.pill--solid {
  --pill-vertical-padding: calc((var(--pill-height) - var(--pill-content-height)) / 2);

  border: none;
  background: var(--neutral-highlight-color);
  color: var(--neutral-color);
}

.pill--clickable {
  cursor: pointer;
}

.pill--compare {
  border-color: var(--compare-color);
}

.pill--compare.pill--solid {
  background: var(--compare-highlight-color);
  color: var(--compare-color);
}

.pill--master-branch {
  border-color: var(--neutral-color);
}

.pill--dev-branch {
  border-color: var(--dev-branch-color);
}

.pill--dev-branch.pill--solid {
  background: var(--dev-branch-color);
}

.pill * {
  display: inline-block;
  height: var(--pill-content-height);
  line-height: var(--pill-content-height);
}

.pill__avatar {
  height: var(--pill-content-height);
  width: var(--pill-content-height);

  border-radius: 100%;
  margin-left: -5px;
  margin-right: calc(var(--base-spacing) / 2);
}
